import { isString } from "lodash";
import { env } from "../../import-meta-env";
import type {
  FieldAddress,
  LinkedRecordItem,
  LinkedRecordTableField,
} from "./types";

export function normalizeLinkedRecordTableFields(
  item: LinkedRecordItem,
): LinkedRecordTableField[] {
  return item.field_list.map((field) => {
    return isString(field) ? { field, width: 1 } : field;
  });
}

export function getLinkedRecordFieldSlugs(item: LinkedRecordItem): string[] {
  return item.field_list.map((field) => {
    return isString(field) ? field : field.field;
  });
}

export function makeGoogleMapsLink(address: string): string {
  const encodedAddress = encodeURIComponent(address);
  return `https://www.google.com/maps?q=${encodedAddress}`;
}

export function makeGoogleMapsStaticMapLink(
  address: string,
  dimensions: { height: number; width: number },
): string {
  const GOOGLE_MAPS_API_KEY = env.VITE_GOOGLE_MAPS_API_KEY;
  const encodedAddress = encodeURIComponent(address);
  const { height, width } = dimensions;
  let scale = 1;

  if (height > 640 || width > 640) {
    scale = 2;
  }

  return `https://maps.googleapis.com/maps/api/staticmap?zoom=13&size=${width}x${height}&scale=${scale}&maptype=roadmap&center=${encodedAddress}&markers=color:red%7C${encodedAddress}&key=${GOOGLE_MAPS_API_KEY}`;
}

export function isValidAddress(address: FieldAddress): boolean {
  // Valid addresses have both latitude and longitude
  return !!address.location_latitude && !!address.location_longitude;
}
